import { applyDemoSelectionSwitch } from './demoSelectionSwitch.part02.js'

export function createDemoSelectionController(state, patch) {
  let agentId = /** @type {string | undefined} */ (undefined)
  let personaId = /** @type {string | undefined} */ (undefined)

  return {
    /**
     * @param {{ agentId: string, personaId: string }} initial
     */
    setInitial(initial) {
      agentId = initial.agentId
      personaId = initial.personaId
      patch({
        askBarAgentId: agentId,
        askBarPersonaId: personaId,
      })
    },

    /**
     * @param {{ agentId?: string, personaId?: string }} next
     */
    switchTo(next) {
      const previousAgentId = agentId
      const previousPersonaId = personaId
      if (next.agentId != null) agentId = next.agentId
      if (next.personaId != null) personaId = next.personaId

      applyDemoSelectionSwitch(state, patch, {
        agentId: next.agentId,
        personaId: next.personaId,
        previousAgentId,
        previousPersonaId,
      })
    },
  }
}
